<template>
  <div class="Polaris-Page">
    <div v-if="isLoading">
      <Spinner />
    </div>
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>
    <div class="Polaris-Page__Content" v-if="config.config">
      <form @submit="handleSubmit">
        <!-- Automation Settings Section -->
        <div
          class="Polaris-InlineGrid"
          style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 2fr 5fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
        >
          <section
            class="Polaris-Box"
            style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <h3 class="Polaris-Text--root Polaris-Text--headingMd">
                Automation Settings
              </h3>
              <p class="Polaris-Text--root Polaris-Text--bodyMd">
                Configure when and how review requests are automatically sent to
                your customers
              </p>
            </div>
          </section>
          <div
            class="Polaris-ShadowBevel"
            style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
              >
                <!-- Enable automation -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label
                        id="enableAutomationLabel"
                        class="Polaris-Label__Text"
                      >
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Enable automation</span
                        >
                      </label>
                    </div>
                  </div>
                  <VSwitch :value="config.isEnabled" @input="handleSwitch" />
                </div>

                <!-- Review request timing -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label
                        id="sendAfterDaysLabel"
                        for="sendAfterDays"
                        class="Polaris-Label__Text"
                      >
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Review request timing</span
                        >
                      </label>
                    </div>
                  </div>
                  <div class="Polaris-Connected">
                    <div
                      class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                    >
                      <div class="Polaris-TextField">
                        <input
                          id="sendAfterDays"
                          type="number"
                          class="Polaris-TextField__Input"
                          placeholder="number between 1 - 70"
                          aria-labelledby="sendAfterDaysLabel"
                          v-model.number="config.config.sendAfterDays"
                          aria-invalid="false"
                        />
                        <div class="Polaris-TextField__Backdrop"></div>
                      </div>
                    </div>
                    <div class="Polaris-Connected__Item">
                      <div class="Polaris-Labelled--hidden">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label
                              id="sendAfterLabel"
                              for="sendAfter"
                              class="Polaris-Label__Text"
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodyMd"
                                >Send after type</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="Polaris-Select">
                          <select
                            id="sendAfter"
                            class="Polaris-Select__Input"
                            v-model="config.config.sendAfter"
                            aria-invalid="false"
                          >
                            <option value="order_created"
                              >days after order created</option
                            >
                            <option value="order_fulfilled"
                              >days after order fulfilled</option
                            >
                          </select>
                          <div
                            class="Polaris-Select__Content"
                            aria-hidden="true"
                          >
                            <span class="Polaris-Select__SelectedOption">{{
                              config.config.sendAfter === "order_created"
                                ? "days after order created"
                                : "days after order fulfilled"
                            }}</span>
                            <span class="Polaris-Select__Icon">
                              <span class="Polaris-Icon">
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                                  ></path>
                                  <path
                                    d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </div>
                          <div class="Polaris-Select__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Review Request Url -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label
                        id="reviewUrlLabel"
                        for="reviewUrl"
                        class="Polaris-Label__Text"
                      >
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Review Request Url</span
                        >
                      </label>
                    </div>
                  </div>
                  <div class="Polaris-Connected">
                    <div
                      class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                    >
                      <div class="Polaris-TextField">
                        <input
                          id="reviewUrl"
                          type="text"
                          class="Polaris-TextField__Input"
                          aria-labelledby="reviewUrlLabel"
                          v-model="config.config.reviewUrl"
                        />
                        <div class="Polaris-TextField__Backdrop"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- InterJambs Section -->

        <div
          class="Polaris-InlineGrid mt-4"
          style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 2fr 5fr; --pc-inline-grid-gap-xs: var(--p-space-400);"
        >
          <section
            class="Polaris-Box"
            style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <h3 class="Polaris-Text--root Polaris-Text--headingMd">
                Email Settings
              </h3>
              <p class="Polaris-Text--root Polaris-Text--bodyMd">
                Customize the email subject and content that will be sent to
                customers when requesting reviews
              </p>
            </div>
          </section>
          <div
            class="Polaris-ShadowBevel"
            style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
              >
                <!-- Email Subject -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label
                        id="emailSubjectLabel"
                        for="emailSubject"
                        class="Polaris-Label__Text"
                      >
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Email Subject</span
                        >
                      </label>
                    </div>
                  </div>
                  <div class="Polaris-Connected">
                    <div
                      class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                    >
                      <div class="Polaris-TextField">
                        <input
                          id="emailSubject"
                          type="text"
                          class="Polaris-TextField__Input"
                          aria-labelledby="emailSubjectLabel"
                          v-model="config.config.emailSubject"
                        />
                        <div class="Polaris-TextField__Backdrop"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email Content -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label id="emailBodyLabel" class="Polaris-Label__Text">
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Email Content</span
                        >
                      </label>
                    </div>
                  </div>
                  <div
                    class="Polaris-Box"
                    style="--pc-box-background: var(--p-color-bg-surface); --pc-box-border: var(--p-border-width-1) solid var(--p-color-border-subdued); --pc-box-border-radius: var(--p-border-radius-200); --pc-box-padding: var(--p-space-200);"
                  >
                    <ckeditor
                      :config="editorConfig"
                      :value="config.config.emailBody"
                      @input="changeEmailBody"
                    ></ckeditor>
                    <div
                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                      style="margin-top: var(--p-space-200);"
                    >
                      When Good and Excellent is clicked customers will be taken
                      to google reviews page. When Bad and Average is clicked
                      customers will be taken to customer feedback form.
                    </div>
                  </div>
                </div>
                <!-- Send Test Email -->
                <div class="">
                  <div class="Polaris-Labelled__LabelWrapper">
                    <div class="Polaris-Label">
                      <label
                        id="testEmailIdLabel"
                        for="testEmailId"
                        class="Polaris-Label__Text"
                      >
                        <span class="Polaris-Text--root Polaris-Text--bodyMd"
                          >Send Test Email to</span
                        >
                      </label>
                    </div>
                  </div>
                  <div class="Polaris-Connected">
                    <div
                      class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                    >
                      <div class="Polaris-TextField">
                        <input
                          id="testEmailId"
                          type="text"
                          class="Polaris-TextField__Input"
                          aria-labelledby="testEmailIdLabel"
                          v-model="testEmailId"
                        />
                        <div class="Polaris-TextField__Backdrop"></div>
                      </div>
                    </div>
                    <div class="Polaris-Connected__Item">
                      <button
                        type="button"
                        class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                        @click="sendTestEmail"
                      >
                        <span
                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                          >Send</span
                        >
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Email Notice -->
                <div
                  class="Polaris-Banner Polaris-Banner--withinPage"
                  tabindex="0"
                  role="status"
                  aria-live="polite"
                >
                  <div class="Polaris-Box" style="--pc-box-width:100%">
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-align:space-between;--pc-block-stack-order:column"
                    >
                      <div
                        class="Polaris-Box"
                        style="--pc-box-color: var(--p-color-text-info-on-bg-fill); --pc-box-background: var(--p-color-bg-fill-info); --pc-box-padding-block-start-xs: var(--p-space-300); --pc-box-padding-block-end-xs: var(--p-space-300); --pc-box-padding-inline-start-xs: var(--p-space-300); --pc-box-padding-inline-end-xs: var(--p-space-300); --pc-box-border-start-start-radius: var(--p-border-radius-300); --pc-box-border-start-end-radius: var(--p-border-radius-300);"
                      >
                        <div
                          class="Polaris-InlineStack"
                          style="--pc-inline-stack-align:space-between;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                        >
                          <div
                            class="Polaris-InlineStack"
                            style="--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-100);--pc-inline-stack-flex-direction-xs:row"
                          >
                            <span class="Polaris-Banner--textInfoOnBgFill">
                              <span class="Polaris-Icon">
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M10 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75Z"
                                  ></path>
                                  <path
                                    d="M9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                  ></path>
                                  <path
                                    fill-rule="evenodd"
                                    d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                            <h2
                              class="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--break"
                            >
                              Email Sender Information
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div
                        class="Polaris-Box"
                        style="--pc-box-padding-block-start-xs:var(--p-space-300);--pc-box-padding-block-end-xs:var(--p-space-300);--pc-box-padding-block-end-md:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-300);--pc-box-padding-inline-start-md:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-300);--pc-box-padding-inline-end-md:var(--p-space-400)"
                      >
                        <div
                          class="Polaris-BlockStack"
                          style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                        >
                          <div>
                            <span
                              class="Polaris-Text--root Polaris-Text--bodyMd"
                            >
                              <p>
                                All review request emails will be sent from our
                                email address (reviews@carthike.com).
                              </p>
                            </span>
                          </div>
                          <div class="Polaris-ButtonGroup">
                            <div class="Polaris-ButtonGroup__Item">
                              <button
                                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                                type="button"
                                @click="openCrispChat"
                              >
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                  >Send from my domain</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <Notification :text="notificationText" :show="showNotification" />
    </div>
  </div>
</template>

<script>
import CKEditor from "ckeditor4-vue";

import VSwitch from "../../components/Common/VSwitch";

import Notification from "../../components/Common/Notification";
import Spinner from "vue-simple-spinner";
import { required, email } from "vuelidate/lib/validators";

import { cloneDeep, isEqual } from "lodash-es";

export default {
  name: "AutomatedConfigureForm",
  components: {
    VSwitch,
    Notification,
    ckeditor: CKEditor.component,
    Spinner
  },

  data() {
    return {
      editorConfig: {
        toolbarGroups: [
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "clipboard", groups: ["clipboard", "undo"] },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker", "editing"]
          },
          { name: "forms", groups: ["forms"] },
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"]
          },
          { name: "links", groups: ["links"] },
          { name: "insert", groups: ["insert"] },
          "/",
          { name: "styles", groups: ["styles"] },
          { name: "colors", groups: ["colors"] },
          { name: "tools", groups: ["tools"] },
          { name: "others", groups: ["others"] }
        ],
        removeButtons:
          "Source,CreateDiv,PageBreak,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Radio,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,CopyFormatting,Outdent,Indent,Language,BidiRtl,BidiLtr,Anchor,Image,Flash,Iframe,SpecialChar,HorizontalRule,Blockquote,Maximize,Strike",
        format_tags: "p;h1;h2;h3;pre",
        allowedContent: {
          $1: {
            // Use the ability to specify elements as an object.
            elements: CKEditor.dtd,
            attributes: true,
            styles: true,
            classes: true
          }
        },
        disallowedContent: "script; *[on*]",
        height: 600
      },
      notificationText: "",
      showNotification: false,
      config: {},
      originalConfig: {},
      templates: [],
      showModal: false,
      appName: "",
      isLoading: false,
      testEmailId: "",
      isFirstLoad: true,
      saveBar: null
    };
  },
  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template => template.elementName === this.config.reviews.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    discountUrl() {
      const { shopOrigin } = this.$store.getters.getStore;
      return `https://${shopOrigin}/admin/discounts/`;
    }
  },
  validations: {
    testEmailId: { required, email }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
  },

  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },

  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getReviewRequestConfig").then(response => {
        this.config = cloneDeep(response.config);
        this.originalConfig = cloneDeep(response.config);
        this.isLoading = false;
      });
    },

    changeEmailBody(value) {
      if (!this.isFirstLoad) {
        this.config.config.emailBody = value;
        // this.isFirstLoad = false;
      } else {
        this.isFirstLoad = false;
      }
    },
    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        console.log({ config: JSON.stringify(this.config) });
        console.log({ originalConfig: JSON.stringify(this.originalConfig) });
        this.saveBar.show();
        console.log("should show contextual bar");
      } else {
        this.saveBar.hide();
      }
    },
    handleSubmit(event) {
      event.preventDefault();
      console.log(this.phoneNumber);
    },
    onSaveBarSaveClicked() {
      this.updateConfig();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },

    save() {
      if (this.hasMoreCharacters) {
        alert("Button Label should be less than 12 characters");
        return;
      }
      this.updateConfig();
    },
    handleSwitch(value) {
      this.config.isEnabled = value;
    },
    updateConfig() {
      const reviewRequestConfig = { ...this.config };
      this.$store
        .dispatch("updateReviewRequestConfig", {
          requestParams: reviewRequestConfig
        })
        .then(response => {
          this.displayNotification("settings updated");
          this.$store.dispatch("updateOnboardingFlag", {
            requestParams: { flag: "isReviewRequestConfigured" }
          });
          this.config = cloneDeep(response.config);
          this.originalConfig = cloneDeep(response.config);
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    sendTestEmail() {
      if (this.$v.$invalid) {
        alert("not valid email id");
        return;
      }
      this.$store
        .dispatch("sendTestEmail", {
          requestParams: {
            email: this.testEmailId,
            mailTemplate: this.config.config.emailBody
          }
        })
        .then(response => {
          if (response.ok) {
            this.$store.dispatch("showNotification", {
              text: "Test email is sent"
            });
          } else {
            this.$store.dispatch("showNotification", {
              text: response.message
            });
          }
        });
    },
    openCrispChat() {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:open"]);
        window.$crisp.push([
          "do",
          "message:send",
          ["text", "I'd like to send review request emails from my own domain"]
        ]);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
